enum CoreRoutePaths {
  ROOT = '/',
  HOME = '/home',
  APPSTORE = '/appstore',
  APP = '/apps/:id',
  MYAPPS = '/myapps',
  INSTANCES = '/instances',
  INSTANCELOG = '/instances/log/:instanceId',
  PLATFORM_USAGE = '/platform-usage',
  CLI_AND_API_ACCESS = '/cli-and-api-access',
  MY_AI_ENGINES = '/aiengines',
  DRIVE = '/drive',
  DRIVE_BUCKET = '/drive/:bucketName',
  LEGACY_ENGINE_LOG = '/aiengines/log/:engineType/:engineName',
  MANAGE_WORKSPACES = '/manage-workspaces',
  AUDIT_TRAIL = '/audit-trail',
  LOGGING_SERVICES = '/logs/',
  ERROR_NOT_FOUND = '/not_found',
  APP_ALIAS = '/v1/latestapp/:appName',
}

enum AdminCenterRoutePaths {
  ADMIN_CENTER_ENTRY = '/admin-center',
  ADMIN_CENTER_AIEM = '/admin-center/aiem',
  ADMIN_CENTER_AI_UNIT_CONSUMPTION = '/admin-center/ai-unit-consumption',
  ADMIN_CENTER_AI_UNIT_HOURLY = '/admin-center/ai-unit-hourly',
  ADMIN_CENTER_AI_UNIT_WORKSPACE = '/admin-center/ai-unit-workspace',
  ADMIN_CENTER_APP_EVENT = '/admin-center/app-events',
  ADMIN_CENTER_INSTANCE_EVENT = '/admin-center/instance-events',
  ADMIN_CENTER_FW_MANAGEMENT = '/admin-center/fw-management',
  ADMIN_CENTER_MEMBER_MANAGEMENT = '/admin-center/member-management',
  ADMIN_CENTER_IDP_MANAGEMENT = '/admin-center/idp-management',
  ADMIN_CENTER_ENV_INFO = '/admin-center/env-info',
  ADMIN_CENTER_MLOPS = '/admin-center/mlops',
  ADMIN_CENTER_USER_LOGIN = '/admin-center/user-login',
  ADMIN_CENTER_H2O_GPTE = '/admin-center/h2o-gpte',
  ADMIN_CENTER_ESCORER = '/admin-center/escorer',
  ADMIN_CENTER_CUSTOM_GROUPS = '/admin-center/custom-groups',
  ADMIN_CENTER_TRUSTED_ROLES = '/admin-center/trusted-roles',
}

enum AdminRoutePaths {
  ADMIN_APPS = '/admin/apps',
  ADMIN_ALIASES = '/admin/aliases',
  ADMIN_INSTANCES = '/admin/instances',
  ADMIN_INSTANCELOG = '/admin/instances/log/:instanceId',
  ADMIN_MARKETPLACE_APPS = '/admin/marketplace/apps',
  ADMIN_MARKETPLACE_APP = '/admin/marketplace/apps/:id',
  ADMIN_SECRETS = '/admin/secrets',
  ADMIN_AI_ENGINES = '/admin/aiengines',
  LEGACY_ADMIN_ENGINE_LOG = '/admin/aiengines/log/:engineType/:engineName',
  AI_ENGINE_SETTINGS = '/admin/aiengines/settings',
  NOTEBOOK_SETTINGS = '/admin/notebook/settings',
  SECURE_STORE_OAUTH_CLIENTS = '/admin/secure-store/oauth-clients',
  SECURE_STORE_SECRETS = '/admin/secure-store/secrets',
  ADMIN_MANAGE_WORKSPACES = '/admin/manage-workspaces',
}

enum OrchestratorRoutePaths {
  ORCHESTRATOR_ENTRY = '/orchestrator',
  ORCHESTRATOR = '/orchestrator/workspaces/:workspace_id',
  ORCHESTRATOR_WORKFLOWS = '/orchestrator/workspaces/:workspace_id/workflows',
  ORCHESTRATOR_WORKFLOW_DETAIL = '/orchestrator/workspaces/:workspace_id/workflows/:workflow_id/:tab_id?/:item_name?',
  ORCHESTRATOR_RUNNABLES = '/orchestrator/workspaces/:workspace_id/runnables',
  ORCHESTRATOR_RUNNABLE_DETAIL = '/orchestrator/workspaces/:workspace_id/runnables/:runnable_id',
  ORCHESTRATOR_ACTIVE_EXECUTIONS = '/orchestrator/workspaces/:workspace_id/activeExecutions',
  ORCHESTRATOR_EXECUTOR_POOLS = '/orchestrator/workspaces/:workspace_id/executorPools',
  ORCHESTRATOR_EXECUTOR_POOL_DETAIL = '/orchestrator/workspaces/:workspace_id/executorPools/:executor_pool_id',
}

enum MLOpsRoutePaths {
  MLOPS_ENTRY = '/mlops',
  MLOPS = '/mlops/workspaces/:workspace_id',
  MLOPS_MODELS = '/mlops/workspaces/:workspace_id/models',
  MLOPS_MODEL_DETAIL = '/mlops/workspaces/:workspace_id/models/:model_id/:action?',
  MLOPS_MODEL_TAGS_MANAGEMENT = '/mlops/workspaces/:workspace_id/models/manage-tags',
  MLOPS_DEPLOYMENTS = '/mlops/workspaces/:workspace_id/deployments',
  MLOPS_DEPLOYMENT_DETAIL = '/mlops/workspaces/:workspace_id/deployments/:deployment_id/:tab_id?/:item_name?',
  MLOPS_BATCH_SCORING = '/mlops/workspaces/:workspace_id/jobs',
  MLOPS_BATCH_SCORING_DETAIL = '/mlops/workspaces/:workspace_id/jobs/:job_id/:tab_id?/:item_name?',
  MLOPS_ADMIN_DEPLOYMENTS = '/mlops/admin/deployments',
  MLOPS_ADMIN_DEPLOYMENT_DETAIL = '/mlops/admin/deployments/:workspace_deployment_id',
  MLOPS_ADMIN_MODELS = '/mlops/admin/models',
  MLOPS_ADMIN_MODEL_DETAIL = '/mlops/admin/models/:workspace_model_id',
}

enum FeaturestoreRoutePaths {
  FEATURESTORE_ROOT = '/featurestore',
  FEATURESTORE_PROJECT = '/featurestore/project',
  FEATURESTORE_PROJECTS = '/featurestore/projects',
  FEATURESTORE_MY_PROJECTS = '/featurestore/my-projects',
  FEATURESTORE_PROJECT_DETAILS = '/featurestore/project/:projectId',
  FEATURESTORE_FEATURE_SET = '/featurestore/feature-set',
  FEATURESTORE_FEATURE_SET_DETAILS = '/featurestore/feature-set/:featureSetId',
  FEATURESTORE_FEATURE_SET_VERSION = '/featurestore/feature-set/:featureSetId/version/:version',
  FEATURESTORE_FEATURE_SET_FEATURE = '/featurestore/feature-set/:featureSetId/:featureId',
  FEATURESTORE_FEATURE_SETS = '/featurestore/feature-sets',
  FEATURESTORE_MY_FEATURE_SETS = '/featurestore/my-feature-sets',
  FEATURESTORE_PROJECT_PERMISSIONS = '/featurestore/project-permissions',
  FEATURESTORE_FEATURE_SETS_PERMISSIONS = '/featurestore/feature-sets-permissions',
  FEATURESTORE_SEARCH_RESULTS = '/featurestore/search-results',
  FEATURESTORE_JOBS = '/featurestore/jobs',
  FEATURESTORE_PENDING_REVIEWS = '/featurestore/pending-reviews',
  FEATURESTORE_PENDING_REVIEWS_DETAILS = '/featurestore/pending-reviews/:reviewId',
  FEATURESTORE_PENDING_FEATURE_SETS = '/featurestore/pending-feature-sets',
  FEATURESTORE_PENDING_FEATURE_SET_DETAILS = '/featurestore/pending-feature-sets/:reviewId',
  FEATURESTORE_PENDING_REVIEW = '/featurestore/pending-review',
  FEATURESTORE_PENDING_FEATURE_SET = '/featurestore/pending-feature-set',
}

export const RoutePaths = {
  ...CoreRoutePaths,
  ...AdminCenterRoutePaths,
  ...AdminRoutePaths,
  ...OrchestratorRoutePaths,
  ...MLOpsRoutePaths,
  ...FeaturestoreRoutePaths,
} as const;

export type RoutePath = (typeof RoutePaths)[keyof typeof RoutePaths];
